import { FormControlLabel, Switch } from "@mui/material";
import type { FC } from "react";

interface Props {
  readonly label: string;
  readonly checked: boolean;
  readonly disabled?: boolean;
  readonly size?: "small" | "medium";
  readonly name?: string;
  readonly onChange: (checked: boolean) => void;
}

const LabelledSwitch: FC<Props> = ({ label, checked, disabled, size, name, onChange }) => (
  <FormControlLabel
    control={<Switch checked={checked} onChange={(_, c) => onChange(c)} disabled={disabled} size={size} name={name} />}
    label={label}
  />
);

export default LabelledSwitch;
